import { TableRow, TableCell, Button, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { SimpleInstalledApplicationDetail } from "../../types/SimpleInstalledApplicationDetail";
import { EllipsisText } from "../../../../components/EllipsisText";

type Props = SimpleInstalledApplicationDetail;

/**
 * 連携アプリ一覧テーブルの行コンポーネントです。
 */
export const InstalledAppsTableRow: React.VFC<Props> = ({
  applicationId,
  name,
  description,
}) => {
  const history = useHistory();

  const moveDetailPage = () => {
    history.push(`/manager/installed-applications/${applicationId}`);
  };

  return (
    <TableRow hover>
      <TableCell>
        <EllipsisText text={name} ignoreMaxLength />
      </TableCell>
      <TableCell>
        <EllipsisText text={description} ignoreMaxLength />
      </TableCell>
      <TableCell style={{ width: "120px" }}>
        <Button
          variant="contained"
          color="primary"
          style={{ width: "70px" }}
          onClick={moveDetailPage}
        >
          <Typography style={{ wordBreak: "keep-all" }}>詳細</Typography>
        </Button>
      </TableCell>
    </TableRow>
  );
};
